export const EXPRESSION_OF_INTEREST_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdebfiVQVoYj4WakqvwY-08k0x9Sfy8HMAUsKPE707YEChGlQ/viewform";
